__turbopack_context__.v({
  "freeBox": "PlasmicLabel-module__oKMMla__freeBox",
  "root": "PlasmicLabel-module__oKMMla__root",
  "slotTargetChildrensize_lg": "PlasmicLabel-module__oKMMla__slotTargetChildrensize_lg",
  "slotTargetChildrensize_sm": "PlasmicLabel-module__oKMMla__slotTargetChildrensize_sm",
  "text": "PlasmicLabel-module__oKMMla__text",
  "textrequirementIndicator_optional": "PlasmicLabel-module__oKMMla__textrequirementIndicator_optional",
  "textrequirementIndicator_required": "PlasmicLabel-module__oKMMla__textrequirementIndicator_required",
});
